import { LogClientDiagnostic } from "../ClientDiagnostics";
import { IsProduction } from "../External/Environment/Environment";

let active = false;
let expired = false;
const listeners = new Set<() => void>();

export function CanUseLocalDevelopmentSession() {
    const hostname = typeof location === "undefined" ? "" : location.hostname;
    return (
        !IsProduction() &&
        ["localhost", "127.0.0.1", "::1", "100.98.181.142"].includes(hostname)
    );
}

interface IClientSessionResponse {
    username?: unknown;
}

export function HasActiveClientSession() {
    return active;
}

export function SubscribeToSessionExpiry(listener: () => void) {
    listeners.add(listener);
    if (expired) listener();
    return () => { listeners.delete(listener); };
}

export function ExpireClientSession() {
    if (expired) return;
    expired = true;
    active = false;
    // Preserve all application data; only remove the stale signed-in marker.
    localStorage.removeItem("username");
    LogClientDiagnostic("client-session", "sign-in-required", { status: 401 });
    listeners.forEach((listener) => listener());
}

export async function CheckClientSessionAsync(signal: AbortSignal) {
    const baseUrl = IsProduction() ? process.env.LOGIC_SERVER_URL : `${location.origin}/`;
    const response = await fetch(`${baseUrl}player/check`, {
        credentials: "include",
        cache: "no-store",
        signal,
    });
    if (signal.aborted || expired) return false;
    if (response.status === 401) {
        ExpireClientSession();
        return false;
    }
    if (!response.ok) {
        throw new Error(`Session check failed (${response.status})`);
    }

    const session = (await response.json()) as IClientSessionResponse;
    if (typeof session.username !== "string" || session.username.trim() === "") {
        throw new Error("Session check returned no username");
    }

    localStorage.setItem("username", session.username);
    active = true;
    return true;
}
